import { appConfig } from '../../../../../../../config/customization';
import { accountsReturnContainer, customerSupportTopbarSize } from '../../../../../../../constants/sizes';
import Device from '../../../../../../../constants/deviceSizes';
import { small } from '../../../../../../../constants/fonts';

export default {
  activeRowStyle: {
    backgroundColor: appConfig.colors.activeRowColor,
    boxShadow: 'inset -2px 73px 46px -87px rgba(0,0,0,1)'
  },
  buttonContainer: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    boxSizing: 'border-box',
    padding: '20px 40px 20px 20px',
    height: accountsReturnContainer
  },
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '10%'
  },
  table: {
    height: '100%',
    paddingTop: 15
  },
  container: {
    height: `calc(100% - ${customerSupportTopbarSize}px)`
  },
  associateContainer: {
    paddingBottom: 3
  },
  associateButton: {
    height: 20,
    width: 20,
    fontSize: small,
    paddingTop: 4,
    [Device.mobile]: {
      marginLeft: 5
    }
  },
  associateButtonText: {
    display: 'flex',
    justifyContent: 'center'
  },
  associateButtonMobile: {
    height: 23,
    fontSize: small,
    paddingTop: 4,
    [Device.mobile]: {
      marginLeft: 5
    }
  }
};
